module.exports = __webpack_public_path__ + "images/category_lp/earphone/assessment_achievements/6_adefbb25a7bf7c88fbdc7cb21f320ec6.jpg";